import { C } from '../../merchants/shared/tokens'

const days = (n) => `${n} day${Math.abs(n) === 1 ? '' : 's'}`

/** How a lane's TAT differs from its base (the standard unless named), by MAX TAT (what EDD uses); MIN-only changes say so. */
export const tatDiff = (min, max, stdMin, stdMax, base = 'standard') => {
  if (max < stdMax) return { tone: 'faster', label: `${days(stdMax - max)} faster` }
  if (max > stdMax) return { tone: 'slower', label: `${days(max - stdMax)} slower` }
  if (min !== stdMin) return { tone: 'same', label: 'MIN only' }
  return { tone: 'same', label: `Same as ${base}` }
}

/** Chip colours per tone. Faster is the one to look at: couriers already miss the standard on many shipments. */
export const DIFF_SX = {
  faster: { color: C.warn, bgcolor: C.warnSoft, border: `1px solid ${C.warnBorder}` },
  slower: { color: C.info, bgcolor: C.infoSoft, border: `1px solid ${C.infoBorder}` },
  same: { color: C.neutral, bgcolor: C.neutralSoft, border: `1px solid ${C.neutralBorder}` },
}
